exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-6ff69cea] .el-badge__content.is-fixed.is-dot{right:5px;top:10px}.el-icon-bell[data-v-6ff69cea]{font-size:21px;cursor:pointer;color:#671E75}\n", ""]);

// exports
